import apiService from './ApiService';

export default class BroadcastSmsApiService {
    /**
     * Get the number of active subscribers who have opted in to text messages, which is who a
     * broadcast would actually reach.
     * @returns {Promise<ServiceResponse<number>>}
     */
    async getReachableSubscriberCount() {
        const response = await apiService.getData('/api/BroadcastSms/subscribers/count');
        return response?.data;
    }

    /**
     * Queue a text message to every subscriber who has opted in
     * @param message {string}
     * @returns {Promise<ServiceResponse<number>>}
     */
    async sendToSubscribers(message) {
        const response = await apiService.postData('/api/BroadcastSms/send', { message });
        return response?.data;
    }
}
